import React, { useState, useContext, useEffect} from "react";
import Modal from "common/Modal.jsx";
import ActionsContext from "common/ActionsContext";

const HelpModal = ({title, content, signal='open-help'}) => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  const doOpen = () => setOpen(true);
  const doClose = () => setOpen(false);
  useEffect( () => actions.recv(signal, doOpen), [])
  if (open !== true) {
    return null;
  }

  return (
    <Modal
      title={title}
      onClose={doClose}
      content={content}
      className="modal-help"
    />
  );
};

export default HelpModal;
